import React, {useMemo} from 'react';
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import EventComment from "../EventComment";
import useKcEventAPI from "../../../common/hooks/useKcEventAPI";
import EventCard from "../EventCard";
import EventChart from "../EventChart";

const Wrapper = styled.div`
  width: 100%;
`;

const ListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 56px;
`;

const KcContent = () => {
    const {t} = useTranslation();
    const {eventQuery,tier_cut} = useKcEventAPI();

    const list = useMemo(() => {
        try {
            if (Array.isArray(eventQuery.list)) {
                return eventQuery.list
            }
            return [];
        } catch (e) {

            console.log("???????",e)
            return [];
        }
    }, [])

    if (list.length === 0) {
        return (
            <Wrapper>
                <GreenBox/>
            </Wrapper>
        )
    }

    return (
        <Wrapper>
            <GreenBox/>
            <EventComment team={eventQuery.eventQuery.team_info.team_name} cheer={t('kc.cheer')}/>
            <ListWrapper>
                {list.map((data, index) => {
                    const splitTier = data.tier.split(" ");
                    return (
                        <EventCard
                            region={'kr'}
                            tag={data.riot_id_tag_line}
                            live={data.live}
                            key={index}
                            lp={data.lp}
                            lose={data.losses}
                            win={data.wins}
                            win_table={data.win_table}
                            division={splitTier[1]}
                            tier={splitTier[0]}
                            name={data.name}
                            nation={'fr'}
                            status={data.status}
                            url_name={data.url_name}
                            puu_id={data.puu_id}
                            riot_id={data.riot_id_name}
                            championship_name={data.championship_name}
                            position={data.position}
                        />
                    )
                })}
            </ListWrapper>
            <EventChart list={list} tierOff={tier_cut} toSummoner={true}/>
            {/*<BannerWrapper>*/}
            {/*    <TitleText>{t('event.title')}</TitleText>*/}
            {/*</BannerWrapper>*/}
            {/*<EventFilter*/}
            {/*    regionList={eventQuery.data.eventRegionList}*/}
            {/*    typeList={eventQuery.data.eventFilter}*/}
            {/*    selectedRegion={selectedRegion}*/}
            {/*    setSelectedRegion={setSelectedRegion}*/}
            {/*    selectedType={selectedType}*/}
            {/*    setSelectedType={setSelectedType}/>*/}
            {/*{list.map((item, index) => {*/}
            {/*    const leader = eventQuery.data.commentList[index];*/}
            {/*    return (*/}
            {/*        <ListWrapper>*/}
            {/*            <EventComment team={leader.team_full} cheer={leader.comment}/>*/}
            {/*            <CardWrapper>*/}
            {/*                <EventPlayerList data={item} room={false}/>*/}
            {/*            </CardWrapper>*/}
            {/*            <EventChart list={item}*/}
            {/*                        tierOff={currentTierOff}/>*/}
            {/*        </ListWrapper>*/}
            {/*    )*/}
            {/*})}*/}
            {/*<BannerWrapper>*/}
            {/*    <img src={`images/event/event_banner_${getBannerName()}.svg`} width={1080} height={52} alt={''}/>*/}
            {/*</BannerWrapper>*/}
            {/*<EventScrimTable teamArray={eventQuery.data.eventArray} scrim={eventQuery.data.scrim}/>*/}
            {/*{eventQuery.data.eventArray.map((data, index) => {*/}
            {/*    return (*/}
            {/*        <EventBox key={index}>*/}
            {/*        </EventBox>*/}
            {/*    )*/}
            {/*})}*/}
            {/*<EventInfo list={eventQuery.data.playerArray} aiList={eventQuery.data.aiScoreArray}/>*/}
        </Wrapper>
    );
};


const GreenBoxWrapper = styled.div`
  margin: 10px 0 20px;
  border: 2px solid ${props => props.theme.color.green_100};
  background-color: ${props => props.theme.color.green_200};
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 96px;
  color: ${props => props.theme.color.green_100};
  font-weight: bold;
  font-size: 20px;
`;

const GreenBox = () => {
    const {t} = useTranslation()
    return (
        <GreenBoxWrapper>
            {t('kc.green')}
        </GreenBoxWrapper>
    )
}

export default KcContent;